import { useState } from 'react';

const useModel = (serviceName: any, methodName: string, defaultValue?) => {
  const [result, setResult] = useState(defaultValue);
  const Service: any = serviceName;

  async function get(...param) {
    const obj: any = new Service();
    const res = await obj[methodName](...param);
    setResult(res);
    return res;
  }

  return [get, result, setResult];
};

useModel.propTypes = {};

export default useModel;
